export default "__VITE_ASSET__b6bee138__"